<!--工单处理界面，左边时间轴和部分按钮，右边聊天窗口和操作项与步骤界面-->
<template>
	<div style="background: white;display: inline-flex !important;" class="flexBetween">
		<div class="leftPart flexStart" :class="{leftPartClose:!showLeft}">
			<img class="showTreeIcon" :src="$store.resourcesStore.getters.getResourcesByName(showLeft?'/wedoButton/toggle_left.png':'/wedoButton/toggle_right.png')" @click="showLeft = !showLeft">
			<div class="axixTab flexBetween" v-show="showLeft">
				<div :class="{isCheck:axisType == 'axis'}" @click="axisType = 'axis'">时间轴</div>
				<div :class="{isCheck:axisType != 'axis'}" @click="axisType = 'info'">信息</div>
			</div>
			<timeAxis v-show="showLeft && axisType == 'axis' " class="hideBar" :dataList="timeAxisDataList"></timeAxis>
			<div class="infoDiv" v-show="showLeft && axisType == 'info'">
				<p class="infoTitle">发起人</p>
				<p class="infoMsg">{{nowOrder.creatorName}}</p>
				<p class="infoTitle">分组</p>
				<p class="infoMsg">{{getOrderGoupName}}</p>
				<p class="infoTitle">创建时间</p>
				<p class="infoMsg">{{getTime(nowOrder.createTime)}}</p>
				<p class="infoTitle">开始时间</p>
				<p class="infoMsg">{{getTime(nowOrder.startTime)}}</p>
				<p class="infoTitle">截至时间</p>
				<p class="infoMsg">{{getTime(nowOrder.startTime + nowOrder.workDay)}}</p>
				<p class="infoTitle">抄送人</p>
				<p class="infoMsg" v-for="user in nowOrderInfo.participants" v-show="isempty == false">{{user.userName}}</p>
				<p class="infoMsg" v-show="isempty == true">无</p>
				<p class="infoTitle">工单描述</p>
				<p style="margin-left: 5px;width: calc(100% - 32px);min-height: 70px;" class="infoMsg">{{nowOrder.content}}</p>
			</div>
		</div>
		<div class="rightPart" :class={rightPartClose:!showLeft}>
			<div style="margin:10px  20px;">
				<span style="font-weight: bold;padding: 5px;">标题: </span>
				<span style="background: #eef1f6;border-radius: 5px;display: inline-block;width: 60%;padding: 5px;">{{nowOrder.title}}</span>
				<div class="nomalButton" @click="toItem = !toItem">{{toItem?'查看操作项':'查看聊天内容'}}</div>
				<div class="nomalButton" @click="uploadAction" v-show="!toItem && isMyNode">提交操作项</div>
			</div>
			<chatListView v-show="toItem" style="height: calc(100% - 60px);" :dataList='nowChatDataList' @pickerFile="uploadFile" @uploadText="uploadText" @sendLocation="sendLocation" @confirm="confirmOrder" @backTo="backTo" @addParticipants="$refs.addParticipantsDialogBean.open()" @removeParticipants="$refs.removeParticipantsDialogBean.open()" @changeLeader="$refs.changeLeaderDialogBean.open()" :isMyNode="isMyNode"></chatListView>
			<editNode ref='editNodeBean' v-show="!toItem" style="height: calc(100% - 60px);width: 100%;" :dataList="nowOrderInfo.next" 
			:nowNodeId='nowOrderInfo.nowNode == undefined?undefined: nowOrderInfo.nowNode.nodeId' :isMyNode="isMyNode" @updateOrderInfo="updateOrderInfo"></editNode>
		</div>
		<dialogBody ref="changeLeaderDialogBean" @cancel='targetParticipants = undefined,$refs.changeLeaderDialogBean.hide()' @confirm='changeLeader'>
			<p slot="title">转派工单</p>
			<listView :dataList="leaderList" nameKey='userName' @checkItem="targetParticipants = $event"></listView>
		</dialogBody>
		<dialogBody ref="removeParticipantsDialogBean" @cancel='targetParticipants = undefined,$refs.removeParticipantsDialogBean.hide()' @confirm='removeParticipants'>
			<p slot="title">移除抄送人</p>
			<listView :dataList="this.nowOrderInfo.participants" nameKey='userName' @checkItem="targetParticipants = $event"></listView>
		</dialogBody>
		<dialogBody ref="addParticipantsDialogBean" @cancel='targetParticipants = undefined,$refs.addParticipantsDialogBean.hide()' @confirm='addParticipants'>
			<p slot="title">添加抄送人</p>
			<p style="margin-bottom: 5px;background: white;border: silver 1px solid;padding: 5px; border-radius: 5px;width: 300px;">抄送人 : {{targetParticipants == undefined?'':targetParticipants.username}}</p>
			<listSelection :targetMethod="targetMethod" :dataList="$store.userStore.getters.getUnitUserTree" class="selection" @checkItem="targetParticipants = $event" :getNameMethod="userSelectionGetNameMethod"></listSelection>
		</dialogBody>
	</div>
</template>

<script>
	import timeAxis from '@/components/module/axis/timeAxis.vue'
	import chatListView from '@/components/module/chat/chatListView.vue'
	import editNode from '@/page/order/dealOrder/editNode.vue'
	import dialogBody from '@/components/module/dialog/dialogBody.vue'
	import listView from '@/components/module/selection/base/listView.vue'
	import listSelection from '@/components/module/selection/base/listSelection.vue'
	export default {
		components: {
			timeAxis,
			chatListView,
			editNode,
			dialogBody,
			listView,
			listSelection,
		},
		props: {},
		data() {
			return {
				axisType: 'axis',
				//当前工单进度轴信息
				nowOrderAxis: [],
				nowOrderInfo: {},
				nowMessageList: [],
				messagePageLen: 20,
				toItem: true,
				showLeft: true,
				//转派、抄送、移除抄送时的指定参与人
				targetParticipants: undefined
			}
		},
		created() {},
		mounted() {
			this.refreshOrderInfo(this.nowOrder)
			debugPage = this
			addNewTask('dealOrderRefreshMessage', 1000, 15000, -1, () => {
				this.refreshMessage(this.nowOrder)
			})
		},
		destroyed() {
			removeTask('dealOrderRefreshMessage')
		},
		computed: {
			isempty() {
				var participants = this.nowOrderInfo.participants
				if(isempty(participants)) {
					return true
				}
				return false
			},
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			getBackgroudColorStyle() {
				return this.$store.resourcesStore.getters.getBackgroudColorStyle
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			getColorById() {
				return this.$store.resourcesStore.getters.getColorById
			},
			getColorStyleById() {
				return this.$store.resourcesStore.getters.getColorStyleById
			},
			nowOrder() {
				return getValueIfNoNull(this.$store.orderStore.state.nowOrder, {})
			},
			nowNodeUserId() {
				return getValueIfNoNull(this.nowOrderInfo.nowNode, {
					next: [{}]
				}).next[0].userId
			},
			timeAxisDataList() {
				var list = []
				var lastInfo = undefined
				for(var i = 0, len = this.nowOrderAxis.length; i < len; i++) {
					var item = this.nowOrderAxis[i]
					//log(item)
					var info = {
						title: '',
						time: '',
						description: '',
						state: 'next'
					}
					if(item.submitTime != undefined) {
						//已经过了
						info.state = 'pass'
						lastInfo = info
						info.time = new Date(item.submitTime).formatByTime()
					} else {
						if(lastInfo != undefined) {
							info.state = 'now'
							lastInfo = undefined
						}
					}
					switch(item.action) {
						case 'Created':
							info.title = '创建'
							info.description = "创建人:" + item.submitterName
							break
						case 'Started':
							info.title = '工单开始'
							break
						case 'Doing':
							info.title = '工单被响应'
							info.description = item.submitterName + '首先响应了工单'
							/* if(item.submitTime == undefined) {
								info.description = '工单还未被响应'
							} else {
								info.description = item.submitterName + '首先响应了工单'
							} */
							break
						case 'Done':
							info.title = '工单完成'
							break
						case 'PointDone':
							info.title = item.content.match(/【([\S\s]*)】/)[1]
							switch(info.state) {
								case 'now':
									info.description = '负责人:' + item.submitterName + ' 执行中'
									break
								case 'pass':
									info.description = '负责人:' + item.submitterName + ' 完成了节点'
									break
								case 'next':
									info.description = '负责人:' + item.submitterName
									break
							}
							break
						case 'PointReturn':
							info.title = '节点退回'
							info.description = item.submitterName + '将' + item.content
							break
						case 'ParticipantsAdd':
							info.title = '添加抄送人'
							info.description = item.content
							break
						case 'ParticipantsRemove':
							info.title = '移除抄送人'
							info.description = item.content
							break
						case 'PointReplace':
							info.title = '转派'
							info.description = item.content
							break
					}
					list.push(info)
				}
				return list
			},
			getOrderGoupName() {
				if(this.nowOrder == undefined) {
					return '未分组'
				}
				return getValueIfNoNull(this.$store.orderGroupStore.getters.getOrderGroupByGroupId(this.nowOrder.groupId), {
					name: '未分组'
				}).name
			},
			getTime() {
				return time => {
					return new Date(time).formatByTime()
				}
			},
			nowChatDataList() {
				//组织用于显示的内容列表
				var list = []
				var date = new Date()
				var nowUserId = this.$store.userStore.state.nowUserInfo.id
				for(var i = 0, len = this.nowMessageList.length; i < len; i++) {
					var item = this.nowMessageList[i]
					var info = {}
					info.messageType = this.nowMessageList[i].messageType
					date.setTime(item.submitTime)
					if(item.action != 'Message') {
						//这是系统消息
						info.type = 'center'
						info.messageBody = item.content + ' ' + date.formatByTime()
					} else {
						info.type = item.submitterId == nowUserId ? 'right' : 'left'
						info.userName = item.submitterName
						info.messageBody = item.content
					}
					//将图片内容转为路径
					if(['jpg', 'png'].includes(item.messageType)) {
						info.imgPath = DWSystemSetting.downloadUrl + item.urlPath + item.resourceName
					} else if(!['time', 'words', 'location'].includes(item.messageType)) {
						//其他附件
						info.filePath = DWSystemSetting.downloadUrl + item.urlPath + item.resourceName
						info.fileType = item.messageType
					}
					list.push(info)
				}
				return list
			},
			isMyNode() {
				return this.nowNodeUserId == this.$store.userStore.state.nowUserInfo.id
			},
			leaderList() {
				//所有参与人员列表
				var list = []
				if(isempty(this.nowOrderInfo)) {
					return list
				}
				//节点负责人列表
				for(var i = 0, len = this.nowOrderInfo.next.length; i < len; i++) {
					var item = this.nowOrderInfo.next[i]
					list.addAll(item.nodeUsers)
				}
				//抄送人列表
				list.addAll(this.nowOrderInfo.participants)
				//排除当前节点负责人
				if(isempty(this.nowOrderInfo.nowNode) || isempty(this.nowOrderInfo.nowNode.next)) {
					return list
				}
				return list.filter(item => {
					return item.userId != this.nowOrderInfo.nowNode.next[0].userId
				})
			},
			// 有定位和图片时可以进行巡检确认
			havaLocationAndImg() {
				var haveLocation = false
				var haveImg = false
				this.nowMessageList.forEach(item => {
					if(item.messageType == 'location') {
						haveLocation = true
					}
					if(['jpg', 'png'].includes(item.messageType)) {
						haveImg = true
					}
				})
				return haveLocation && haveImg
			}
		},
		watch: {
			nowOrder(nv, ov) {
				this.refreshOrderInfo(nv)
			}
		},
		methods: {
			refreshOrderInfo(order) {
				if(order == undefined || order.orderId == undefined) {
					return
				}
				//刷新时间轴
				this.$api.messageApi.searchActionMessageAndNodes(order.orderId, respon => {
					this.nowOrderAxis = respon
				})
				//刷新工单信息
				this.$api.orderApi.getOrderInfoById(order.orderId, respon => {
					this.nowOrderInfo = respon
				})
				//获取最近的20条聊天信息
				this.$api.messageApi.searchMessage(order.orderId, 1, this.messagePageLen, undefined, respon => {
					//排个序
					this.nowMessageList = respon.sort((a, b) => {
						return a.pkid - b.pkid
					})
				})
			},
			//刷新工单信息
			updateOrderInfo() {
				this.$api.orderApi.getOrderInfoById(this.nowOrder.orderId, respon => {
					//log(respon)
					this.nowOrderInfo = respon
				})
			},
			uploadFile(form) {
				if(['NotStarted', 'OvertimeDone', 'Done', 'Stopping', 'BreakOff', 'Deleted'].includes(this.nowOrderInfo.status)) {
					this.$dialogMethod.showMessage("当前工单已停止编辑!")
					return
				}
				this.$api.resourcesApi.uploadByBytes(form, respon => {
					this.$dialogMethod.showMessage("上传成功!")
					this.$api.messageApi.sendMessage(this.nowOrder.orderId, respon.id, respon.type, respon => {
						this.refreshMessage(this.nowOrder)
					})
				}, respon => {
					this.$dialogMethod.showMessage("上传失败!")
				})
			},
			uploadText(text) {
				if(['NotStarted', 'OvertimeDone', 'Done', 'Stopping', 'BreakOff', 'Deleted'].includes(this.nowOrderInfo.status)) {
					this.$dialogMethod.showMessage("当前工单已停止编辑!")
					return
				}
				if(isempty(text)) {
					this.$dialogMethod.showMessage("内容不能为空!")
					return
				}
				this.$api.messageApi.sendMessage(this.nowOrder.orderId, text, 'words', respon => {
					this.refreshMessage(this.nowOrder)
				})
			},
			// 发送定位信息
			sendLocation(point) {
				if(['NotStarted', 'OvertimeDone', 'Done', 'Stopping', 'BreakOff', 'Deleted'].includes(this.nowOrderInfo.status)) {
					this.$dialogMethod.showMessage("当前工单已停止编辑!")
					return
				}
				this.$api.messageApi.sendMessage(this.nowOrder.orderId, JSON.stringify(point), 'location', respon => {
					this.refreshMessage(this.nowOrder)
					this.$dialogMethod.closeLoading()
				})
			},
			refreshMessage(order) {
				if(isempty(order)) {
					return
				}
				//获取最新工单信息
				this.$api.orderApi.getOrderInfoById(order.orderId, respon => {
					this.nowOrderInfo = respon
					//比对聊天消息的数量差距
					var last = this.nowOrder.messageCount
					var now = respon.messageCount
					if(now > last) {
						this.nowOrder.messageCount = now
						//有消息等着获取
						this.$api.messageApi.searchMessage(order.orderId, 1, now - last, undefined, respon2 => {
							this.nowMessageList.addAll(respon2.sort((a, b) => {
								return a.pkid - b.pkid
							}))
							//如果有时间轴消息就刷新时间轴
							if(respon2.find(item => {
									return item.action != 'Message'
								}) != undefined) {
								//刷新时间轴
								this.$api.messageApi.searchActionMessageAndNodes(order.orderId, respon => {
									this.nowOrderAxis = respon
								})
							}
						})
					}
				})
			},
			confirmOrder() {
				//判定是否当前节点负责人
				if(!this.isMyNode) {
					this.$dialogMethod.showMessage('只有当前节点负责人可以确认节点！')
					return
				}
				// 当前节点类型为现场交底时判断是否上传定位和图片
				if(!this.havaLocationAndImg && this.nowOrderInfo.nowNode.nodeType == 1) {
					this.$dialogMethod.showMessage('现场交底需要上传现场图片和现场定位信息')
					return
				}
				//节点确认
				this.$dialogMethod.openAgreeDialog('节点通过', '请确定您的节点已经完成，否则请点取消。', respon => {
					this.$api.orderApi.confirmNode(this.nowOrderInfo.orderId, this.nowOrderInfo.nowNode.nodeId, respon => {
						this.$dialogMethod.showMessage('节点确认通过！')
						this.refreshMessage(this.nowOrder)
					})
				})
			},
			backTo() {
				this.$dialogMethod.openAgreeDialog('节点回滚', '是否将节点回滚到上一个？', respon => {
					//回滚到上一个节点
					this.$api.orderApi.nodeReturn(this.nowOrderInfo.orderId, this.nowOrderInfo.nowNode.nodeId, respon => {
						this.$dialogMethod.showMessage('节点已经回滚到上一个节点！')
						this.refreshMessage(this.nowOrder)
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			uploadAction() {
				if(!this.isMyNode) {
					this.$dialogMethod.showMessage('只有当前节点负责人可以提交检查项！')
					return
				}
				var nowData = this.$refs.editNodeBean.getUploadData()
				if(isempty(nowData)) {
					this.$dialogMethod.showMessage('检查项未做修改！')
					return
				}
				this.$api.orderApi.updateCheckAction(this.nowOrder.id, nowData, respon => {
					this.$dialogMethod.showMessage('检查项已经提交！')
					//重置操作项
					this.refreshMessage(this.nowOrder)
					this.$refs.editNodeBean.changeId = {}
				})
			},
			userSelectionGetNameMethod(item) {
				if(item == undefined) {
					return '未选中'
				}
				if(item.userName != undefined) {
					return item.userName
				}
				return item.name
			},
			targetMethod(item) {
				if(item.type != "PcmUser") {
					return false
				}
				return true
			},
			addParticipants() {
				//新增抄送人
				if(this.targetParticipants == undefined) {
					this.$dialogMethod.showMessage('请先选择一个用户!')
					return
				}
				if(this.leaderList.find(item => {
						return item.userId == this.targetParticipants.userId
					}) != undefined) {
					this.$dialogMethod.showMessage('用户已经在工单中!')
					return
				}
				this.$api.orderApi.addParticipantsInNode(this.nowOrderInfo.orderId, this.targetParticipants.userId, respon => {
					this.targetParticipants = undefined
					this.$refs.addParticipantsDialogBean.hide()
					this.$dialogMethod.showMessage('抄送成功!')
					this.refreshMessage(this.nowOrder)
				}, respon => [
					this.$dialogMethod.showMessage(respon)
				])
			},
			removeParticipants() {
				//移除抄送人
				if(this.targetParticipants == undefined) {
					this.$dialogMethod.showMessage('请先选择一个用户!')
					return
				}
				this.$api.orderApi.removeParticipantsInNode(this.nowOrderInfo.orderId, this.targetParticipants.userId, respon => {
					this.targetParticipants = undefined
					this.$refs.removeParticipantsDialogBean.hide()
					this.$dialogMethod.showMessage('移除成功!')
					this.refreshMessage(this.nowOrder)
				}, respon => [
					this.$dialogMethod.showMessage(respon)
				])
			},
			changeLeader() {
				//转派
				if(this.targetParticipants == undefined) {
					this.$dialogMethod.showMessage('请先选择一个用户!')
					return
				}
				this.$api.orderApi.replaceNodeUser(this.nowOrderInfo.orderId, this.targetParticipants.userId, respon => {
					this.targetParticipants = undefined
					this.$refs.changeLeaderDialogBean.hide()
					this.$dialogMethod.showMessage('转派成功!')
					this.refreshMessage(this.nowOrder)
				}, respon => [
					this.$dialogMethod.showMessage(respon)
				])
			}
		}
	}
</script>

<style scoped>
	.leftPart {
		height: 100%;
		min-width: 400px;
		display: inline-flex;
		overflow-y: auto;
		border-right: .01rem #bcbcbc solid;
		flex-direction: column;
		position: relative;
	}
	
	.leftPartClose {
		min-width: 70px !important;
	}
	
	.leftPart>.showTreeIcon {
		position: absolute;
		left: 10px;
		top: 10px;
		width: 50px;
		cursor: pointer;
	}
	
	.axixTab {
		margin: 20px 0;
		height: 30px;
		display: inline-flex;
	}
	
	.axixTab>div {
		width: 80px;
		height: 32px;
		line-height: 30px;
		font-size: .16rem;
		color: black;
		text-align: center;
		cursor: pointer;
		border-radius: 10px 0 0 10px;
		border: #1890ff solid 1px;
	}
	
	.axixTab>div:nth-child(2) {
		border-radius: 0 10px 10px 0;
	}
	
	.axixTab>.isCheck {
		background: #1890ff;
		color: white;
	}
	
	.infoDiv {
		width: 300px;
	}
	
	.infoDiv>p {
		margin: .05rem;
		padding: .05rem .1rem;
	}
	
	.infoDiv>.infoTitle {
		font-weight: bold;
	}
	
	.infoDiv>.infoMsg {
		background: #eef1f6;
		border-radius: 5px;
		word-break: break-all;
	}
	
	.rightPart {
		height: 100%;
		width: calc(100% - 402px);
	}
	
	.rightPartClose {
		width: calc(100% - 72px);
	}
</style>